import { styleVariants } from '@vanilla-extract/css';

const quoteVariants = ['1', '2', '3'];

export const blockquoteFigureContainer = styleVariants(
  quoteVariants.reduce(
    (acc, variant) => {
      acc[variant] = {
        paddingTop: `var(--wt-quote${variant !== '1' ? `-${variant}` : ''}-margin-top)`,
        paddingRight: `calc(var(--wt-quote${variant !== '1' ? `-${variant}` : ''}-margin-right, 0px) + var(--wt-padding, 0px))`,
        paddingBottom: `var(--wt-quote${variant !== '1' ? `-${variant}` : ''}-margin-bottom)`,
        paddingLeft: `calc(var(--wt-quote${variant !== '1' ? `-${variant}` : ''}-margin-left, 0px) + var(--wt-padding, 0px))`,
      };
      return acc;
    },
    {} as Record<string, any>,
  ),
);

export const blockquoteFigure = styleVariants({
  '1': {
    borderTopWidth: 'var(--wt-quote-border-top-width)',
    borderRightWidth: 'var(--wt-quote-border-right-width)',
    borderBottomWidth: 'var(--wt-quote-border-bottom-width)',
    borderLeftWidth: 'var(--wt-quote-border-left-width)',
    borderStyle: 'solid',
    borderColor: 'var(--wt-quote-border-color)',
    borderRadius:
      'var(--wt-quote-border-radius-top-left) var(--wt-quote-border-radius-top-right) var(--wt-quote-border-radius-bottom-right) var(--wt-quote-border-radius-bottom-left)',
    paddingLeft: 'var(--wt-quote-padding-left)',
    paddingRight: 'var(--wt-quote-padding-right)',
    paddingTop: 'var(--wt-quote-padding-top)',
    paddingBottom: 'var(--wt-quote-padding-bottom)',
    backgroundColor: 'var(--wt-quote-background-color)',
  },
  '2': {
    borderLeftWidth: 'var(--wt-quote-2-border-left-width)',
    borderLeftStyle: 'solid',
    borderLeftColor: 'var(--wt-quote-2-border-color)',
    borderRadius:
      'var(--wt-quote-2-border-radius-top-left) var(--wt-quote-2-border-radius-top-right) var(--wt-quote-2-border-radius-bottom-right) var(--wt-quote-2-border-radius-bottom-left)',
    paddingLeft: 'var(--wt-quote-2-padding-left)',
    paddingRight: 'var(--wt-quote-2-padding-right)',
    paddingTop: 'var(--wt-quote-2-padding-top)',
    paddingBottom: 'var(--wt-quote-2-padding-bottom)',
    backgroundColor: 'var(--wt-quote-2-background-color)',
  },
  '3': {
    borderTopWidth: 'var(--wt-quote-3-border-top-width)',
    borderRightWidth: 'var(--wt-quote-3-border-right-width)',
    borderBottomWidth: 'var(--wt-quote-3-border-bottom-width)',
    borderLeftWidth: 'var(--wt-quote-3-border-left-width)',
    borderStyle: 'solid',
    borderColor: 'var(--wt-quote-3-border-color)',
    borderRadius:
      'var(--wt-quote-3-border-radius-top-left) var(--wt-quote-3-border-radius-top-right) var(--wt-quote-3-border-radius-bottom-right) var(--wt-quote-3-border-radius-bottom-left)',
    paddingLeft: 'var(--wt-quote-3-padding-left)',
    paddingRight: 'var(--wt-quote-3-padding-right)',
    paddingTop: 'var(--wt-quote-3-padding-top)',
    paddingBottom: 'var(--wt-quote-3-padding-bottom)',
    backgroundColor: 'var(--wt-quote-3-background-color)',
  },
});
